import { Loader2 } from 'lucide-react';

import { Button } from 'components/ui/button';
import { ScrollArea } from 'components/ui/scroll-area';
import { checkSpanishLocale, extractLabelAndComment } from 'lib/utils';
import { QuestionnaireItem } from 'types';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface QuestionnaireContainerProps {
  children: React.ReactNode;
  questionData: QuestionnaireItem | undefined;
  onContinue: () => void;
  isLoading: boolean;
  disabled?: boolean;
  questionNumber: number;
}

export default function QuestionnaireContainer({
  children,
  questionData,
  onContinue,
  isLoading,
  questionNumber,
  disabled = false,
}: QuestionnaireContainerProps) {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const { t } = useTranslation();

  const isSpanish = checkSpanishLocale();

  const { label } = extractLabelAndComment(
    questionData?.[isSpanish ? 'spanish_question' : 'eng_question'] ?? ''
  );
  return (
    <div>
      <ScrollArea className='h-full md:h-[calc(100vh-20.75rem)]'>
        <div className='flex-1 px-4 pt-3 pb-3 lg:pt-4'>
          <h2 className='text-base font-semibold lg:text-lg'>
            {t('question')} #{questionNumber}
          </h2>

          <div className='mt-2 lg:mt-3'>
            <p className='mb-4 text-sm font-semibold lg:text-base'>{label}</p>
            <div>{children}</div>
          </div>
        </div>
      </ScrollArea>
      <div className='flex justify-center mt-3'>
        <Button
          className='px-6 h-9'
          onClick={onContinue}
          disabled={isLoading || disabled}
        >
          {isLoading && <Loader2 className='mr-2 animate-spin size-4' />}
          {code ? t('update') : t('continue')}
        </Button>
      </div>
    </div>
  );
}
